export const DEPARTMENT_CODES = {
    ACTUARIAL: "DEPT_ACTUARIAL",
    IT: "DEPT_IT",
    MKT_GMS: "DEPT_MKT_GMS",
    SALES_AND_MKT: "DEPT_SALES_&_MKT",
    AMS: "DEPT_AMS",
    MKT_ASST: "DEPT_MKT_ASST",
    EBAM: "DEPT_EBAM"
} as const;

export const USER_ROLES_CODES = {
    TL: 'Team Leader',
    SA: 'Super Admin'
} as const;